<template>
  <div>
    <b-form @submit.prevent>
      <b-row>
        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold">Email :</span><a :href="'/accounts/'+this.$route.params.email"><span style="font-weight: bold;padding-bottom: 10px"> {{ this.$route.params.email }} </span></a>
          </div>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Book ID : {{ this.$route.params.id }} </span>
          </div>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Transaction ID : {{ purchase.transactionId }} </span>
          </div>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Store : {{ purchase.store }} </span>
          </div>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Device ID : {{ purchase.deviceId }} </span>
          </div>
        </b-col>

        <br><br>

        <b-col cols="12">
          <b-form-group
            label="Status"
            label-for="vi-status"
          >
            <b-form-select
              v-model="purchase.status"
              :options="states"
            />
          </b-form-group>
        </b-col>

        <br>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Created At: {{ formatDate(purchase.created) }}</span>  ,  Last Update: {{ formatDate(purchase.updated) }}
          </div>
        </b-col>

        <div class="demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="askUpdatePurchase"
          >
            Save
          </b-button>
        </div>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
  BRow, BCol, BForm, BButton, BFormGroup, BFormSelect,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BFormGroup,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      purchase: {},
      states: [
        { value: null, text: 'Please select an status' },
        { value: 'PENDING', text: 'PENDING' },
        { value: 'IN_PROGRESS', text: 'IN_PROGRESS' },
        { value: 'COMPLETED', text: 'COMPLETED' },
        { value: 'ERROR', text: 'ERROR' },
        { value: 'DELETED', text: 'DELETED' },
      ],
    }
  },
  mounted() {
    const purchaseId = window.btoa(`${this.$route.params.id}/${this.$route.params.email}`)
    const url = `${this.$readerURL}/admin/purchases/${purchaseId}`
    this.loader('block')
    firebase.auth().currentUser.getIdToken(false).then(idToken => {
      axios.get(url,
        {
          headers: {
            Authorization: idToken,
          },
        }).then(response => {
        this.purchase = response.data
        this.loader('none')
        return response
      }).catch(error => {
        this.loader('none')
        return error
      })
    })
  },
  methods: {
    askUpdatePurchase() {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to update purchase status', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Save',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.savePurchase()
          }
        })
    },
    savePurchase() {
      const purchaseId = window.btoa(`${this.$route.params.id}/${this.$route.params.email}`)
      const url = `${this.$readerURL}/admin/purchases/${purchaseId}`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, this.purchase,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.purchase = response.data
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    delete() {
      const purchaseId = window.btoa(`${this.$route.params.id}/${this.$route.params.email}`)
      const url = `${this.$readerURL}/admin/purchases/${purchaseId}`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.delete(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$router.push('/purchases/')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    askDelete() {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this purchase.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.delete()
          }
        })
    },
  },
}
</script>
